import { axiosSwagger } from "@/axios";

export const state = {
  deliveryUnitAccess: {
    loading: false,
    data: [],
    total: 0,
  },
}


export const getters = {
}


export const mutations = {
  // ACCESS LEVEL
  loading: (state, loading) => {
    state.deliveryUnitAccess.loading = loading;
  },
  setData: (state, data) => {
    state.deliveryUnitAccess.data = data;
  },
  setTotal: (state, total) => {
    state.deliveryUnitAccess.total = total;
  },
  add: (state, data) => { 
    state.deliveryUnitAccess.data.push(data);
  },
  remove: (state, id) => {
    state.deliveryUnitAccess.data = state.deliveryUnitAccess.data.filter((el) => el.id !== id);
  },
  // update: (state, data) => {
  //     const index = state.deliveryUnitAccess.data.findIndex(
  //         (item) => item.id === data.id
  //     );

  //     if (index !== -1) {
  //         state.deliveryUnitAccess.data[index].applicationUserId = data.applicationUserId;
  //         state.deliveryUnitAccess.data[index].deliveryUnitIds = data.deliveryUnitIds;
  //     }
  // },
}


export const actions = {
    // ACCESS LEVEL
    async readMyDeliveryUnitAccess({ commit }) {
      commit("loading", true);

      return await axiosSwagger
      .get("/api/DeliveryUnitAccess/My")
      .then((response) => {
        commit("setData", response.data);
        commit("setTotal", response.data.length);
        commit("loading", false);

        return response;
      })
      .catch(() => {
        commit("loading", false);
      });
    },
    async createDeliveryUnitAccess({ commit }, data) {
      return await axiosSwagger
      .post(`/api/DeliveryUnitAccess/Add`, data)
      .then((response) => {
        commit("add", response.data);

        return response;
      });
    },
    async deleteDeliveryUnitAccess({ commit }, id) {
      return await axiosSwagger
      .delete(`/api/DeliveryUnitAccess/Remove/${id}`)
      .then((response) => {
        commit("remove", id);

        return response;
      });
    },
    // async updateCampusAccess({ commit }, data) {
    //     return await axiosSwagger
    //     .put(`/api/DeliveryUnitAccess/Update/${data.id}/${data.access}`)
    //     .then((response) => {
    //         commit("update", data);

    //         return response;
    //     });
    // },
    // eslint-disable-next-line no-unused-vars
    async readDeliveryUnitAccessByUserId({ commit }, data) {
      return await axiosSwagger
      .post("/api/DeliveryUnitAccess/User", data)
      .then((response) => {

        return response;
      });
    },
}
